"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyTable = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = require("styled-components");
const Colors_1 = require("../../Colors");
const GlobalStateProvider_1 = require("../../GlobalStateProvider");
const element_1 = require("../element");
const EmptyStyled = styled_components_1.styled.div `
	${props => props.$isMobile
    ? (0, styled_components_1.css) `
					& {
						width: 100%;
						height: 100%;
						display: flex;
						flex-direction: column;
						gap: 8px;
						align-items: center;
						justify-content: center;
						position: relative;
					}

					&:not(.button) {
						p {
							color: var(--color-grey, #666666);
							text-align: left;
							font-family: 'Noto Sans KR', sans-serif;
							font-size: 16px;
							line-height: 150%;
							letter-spacing: -0.02em;
							font-weight: 400;
							position: relative;
							display: flex;
							align-items: center;
							justify-content: flex-start;
						}
					}
			  `
    : props.$isTablet
        ? (0, styled_components_1.css) `
					& {
						width: 100%;
						height: 100%;
						display: flex;
						flex-direction: column;
						gap: 8px;
						align-items: center;
						justify-content: center;
						position: relative;
					}

					&:not(.button) {
						p {
							color: var(--color-grey, #666666);
							text-align: left;
							font-family: 'Noto Sans KR', sans-serif;
							font-size: 18px;
							line-height: 150%;
							letter-spacing: -0.02em;
							font-weight: 400;
							position: relative;
							display: flex;
							align-items: center;
							justify-content: flex-start;
						}
					}
			  `
        : (0, styled_components_1.css) `
					& {
						width: 100%;
						height: 100%;

						display: flex;
						flex-direction: column;
						gap: 20px;
						align-items: center;
						justify-content: center;
						flex-shrink: 0;
					}

					&:not(.button) {
						p {
							color: var(--color-grey, #666666);
							text-align: left;
							font-family: var(--b1-font-family, 'Noto Sans KR', sans-serif);
							font-size: var(--b1-font-size, 20px);
							line-height: var(--b1-line-height, 42px);
							letter-spacing: var(--b1-letter-spacing, -0.02em);
							font-weight: var(--b1-font-weight, 400);
							position: relative;
							display: flex;
							align-items: center;
							justify-content: flex-start;
						}
					}
			  `}
`;
exports.EmptyTable = react_1.default.memo(({ title, iconProps, }) => {
    const { isMobile, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement(EmptyStyled, { className: "empty_data", "$isMobile": isMobile, "$isTablet": isTablet, style: { color: Colors_1.Colors.light_grey } },
        iconProps && react_1.default.createElement(element_1.Icon, { ...iconProps }),
        t(title)));
});
